const SELECT2_SKIP_SELECTOR =
    '.select2-ignore, .entityItemInput, .ui-datepicker-month, .ui-datepicker-year, .rowsOnPageSelect';

function getSelect2DropdownParent($el) {
    const $modal = $el.closest('.modal');
    if ($modal.length) {
        return $modal;
    }

    return $(document.body);
}

/** Select2 for admin forms — multiselect and single selects (replaces legacy global init). */
export function initFormSelects(root: ParentNode | Document = document): void {
    const $ = window.jQuery;
    if (!$?.fn?.select2) {
        return;
    }

    const scope = root === document ? $(document) : $(root);
    scope.find(`select:not(${SELECT2_SKIP_SELECTOR})`).each(function eachFormSelect() {
        const $el = $(this);
        if ($el.data('select2')) {
            return;
        }

        const $dropdownParent = getSelect2DropdownParent($el);
        const widthAttr = $el.attr('data-select2-width');
        $el.select2({
            width: widthAttr && widthAttr.length > 0 ? widthAttr : '100%',
            dropdownParent: $dropdownParent.length ? $dropdownParent : $(document.body),
        });
    });
}

window.init_form_selects = initFormSelects;
